import { useTranslation } from "i18n";
import { FilmmakersLogo } from "assets";

const FilmmakersButtonContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <span className="transition-transform group-hover:scale-110">
        <FilmmakersLogo />
      </span>
      {t("common:profile.button.filmmakersEurope")}
    </>
  );
};

export default FilmmakersButtonContent;
